var render = function render(){var _vm=this,_c=_vm._self._c;return _c('generic-container',{ref:"container",attrs:{"title":_vm.$t('task') + _vm.task_title,"icon":"list","wide":_vm.wide,"header_buttons":_vm.header_buttons,"id":"cntnr"}},[_c('div',{staticClass:"ui form",attrs:{"id":"instance_form"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }